import React from 'react'

function NotFound() {
  return (
    <h3>Path not found!</h3>
  )
}

export default NotFound;
